import styled from 'styled-components';

export const ContentPage = styled.div`
    padding: calc(100vw * 0.04) var(--page-gutter);
    margin: 0 auto;
    max-width: 900px;
    color: var(--ink-inverse);
    background-color: var(--surface-2);

    h1 {
        margin-bottom: 44px;
        font-family: var(--font-display);
        text-transform: uppercase;
        letter-spacing: 1px;
        color: var(--ink-inverse);
    }

    h2 {
        font-family: var(--font-heading);
        font-size: 24px;
        margin-bottom: 12px;
        color: var(--ink-inverse);
    }

    p {
        font-size: var(--text-body);
        line-height: var(--leading-body);
        color: rgba(255, 255, 255, 0.8);
    }

    a {
        color: var(--brand);

        &:hover {
            color: var(--brand-hover);
        }
    }
`;
